import React ,{useState} from 'react'
import { Modal } from "reactstrap";
import PropTypes from "prop-types"
import { toast } from "react-toastify";
import deleteImg from "../../assets/images/trash.svg"

function DeleteMultiModal(props) {
    const [loading, setLoading] = useState(false)

    const handleDeletedItem = () => {
        setLoading(true)
        props.modelService.removeMulti(props.idsSelected).then(res=>{
            if(res?.status === 200){
                toast.success("Deleted Successfully.")
                props?.setShouldGetData(prev=> !prev)
                props.onCloseModal()
                return
            }
            setLoading(false)
            toast.error("Error Occurred")
        }).catch(()=> setLoading(false));
    }
    return (
        <Modal isOpen={props.open}   >
            <div className="modal-header border-0">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    <img src={deleteImg} alt="delete" /> Delete {props.titleMsg}
                </h5>
                <button
                    type="button"
                    onClick={() => props.onCloseModal()}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body border-0">
                <p>
                    {`Kindly note that this action can't be undone and the ${props.titleMsg} details will get deleted.`}
                </p>
            </div>
            <div className="modal-footer border-0">
                <button
                    type="button"
                    onClick={() => props.onCloseModal()}
                    className="btn me-auto btn-secondary waves-effect waves-light"
                    data-dismiss="modal"
                >
                    Cancel
            </button>
                <button
                    onClick={handleDeletedItem}
                    type="button"
                    className="btn btn-success waves-effect"
                    disabled={loading ? true : false}

                >
                    Delete
            </button>
            </div>
        </Modal>
    )
}

DeleteMultiModal.propTypes = {
    open: PropTypes.bool,
    onCloseModal: PropTypes.func,
    handleTableChange: PropTypes.func,
    idsSelected: PropTypes.object,
    modelService: PropTypes.object,
    titleMsg: PropTypes.string
};

export default DeleteMultiModal
